import React from "react"
import styled from "styled-components"
import Image from "gatsby-image"
import Arrow from "../../assets/arrow-right.png"

const Item = ({ item, image }) => {
  return (
    <Wrapper>
      <div className="small">
        <h3 className="title">{item.title}</h3>
        <div className="subtitle">{item.subtitle}</div>
        <div className="content">
          <div className="text">
            <p>{item.text}</p>
            {item.text2 && <p>{item.text2}</p>}
          </div>
          <div className="image">
            <Image fluid={image.childImageSharp.fluid} alt={item.title} />
          </div>
        </div>
        <a className="view" href={item.url}>VIEW<img src={Arrow} alt="visit site" /></a>
      </div>

      <div className="large">
        
        <div className="text">
          <h3 className="title">{item.title}</h3>
          <div className="subtitle">{item.subtitle}</div>
          <p>{item.text}</p>
          {item.text2 && <p>{item.text2}</p>}
          <a className="view" href={item.url}>VIEW<img src={Arrow} alt="visit site" /></a>
        </div>
        <div className="image">
          <Image fluid={image.childImageSharp.fluid} alt={item.title} />
        </div>
      </div>

      
    </Wrapper>
  )
}

const Wrapper = styled.article`
  margin-bottom: 100px;
  padding: 0 20px;

  .large {
    display: none;
  }
  .content {
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 28px;
    line-height: 44px;
  }
  .subtitle {
    font-weight: bold;
    font-size: 12px;
    line-height: 190%;
  }
  p {
    margin-top: 18px;
    font-size: 12px;
    line-height: 190%;
  }
  .image {
    display: block;
    width: 100%;
    margin: 0 auto;
  }
  .text {
  }
  .view {
    margin-top: 18px;
    font-size: 14px;
    line-height: 21px;
    color: var(--clr-primary-1);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    img {
      margin-left: 20px;
      height: 8px;
      width: 31px;
    }
  }
  @media screen and (min-width: 360px) {
    padding: 0 57px;
  }

  @media screen and (min-width: 768px) {
    padding: 0 77px;
    .content {
      flex-direction: row;
      align-items: center;
    }

    .text {
      flex-basis: 70%;
    }
    .image {
      flex-basis: 30%;
      margin-left: 20px;
    }
  }
  @media screen and (min-width: 1024px) {
    margin: 100px 129px;
  }

  @media screen and (min-width: 1025px) {
    margin: 0px;
    margin-bottom: 67px;
    padding: 0px;
    .small {
      display: none;
    }
    .large {
      display: flex;
      align-items: center;
    }
    .text {
      flex-basis: 70%;  
    }
    p {
      font-size: 14px;
    }
    .image {
      flex-basis: 25%;
      margin-left: 100px;
    }
  }
`

export default Item
